var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5462L3.8769 8.4231L5.1417 7.1217L8.1 10.08V0H9.9V10.08L12.8583 7.1217L14.1231 8.4231L9 13.5462ZM2.1693 18C1.5631 18 1.05 17.79 0.63 17.37C0.21 16.95 0 16.4369 0 15.8307V12.5769H1.8V15.8307C1.8 15.9231 1.8385 16.0077 1.9155 16.0845C1.9923 16.1615 2.0769 16.2 2.1693 16.2H15.8307C15.9231 16.2 16.0077 16.1615 16.0845 16.0845C16.1615 16.0077 16.2 15.9231 16.2 15.8307V12.5769H18V15.8307C18 16.4369 17.79 16.95 17.37 17.37C16.95 17.79 16.4369 18 15.8307 18H2.1693Z",
    fill: "url(#paint0_linear_1588_2643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1588_2643",
    x1: 0,
    y1: 9,
    x2: 18,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDownload);
export default __webpack_public_path__ + "static/media/vector-download.7b7d19181b20c5c117a4a986e25ae0cc.svg";
export { ForwardRef as ReactComponent };